import React, {useState} from 'react';
import SearchCarto from "../carto/searchCarto";
import { UserModal, UserItem } from "./user_modal";
import { changeOwner, updateGrid } from "../api";
import {useTranslation} from "react-i18next";
import { useForm } from 'react-hook-form';

function SettingsPanel({data, router, theme_id}) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  const owner_id = data.grid?.owner_id;

  const user = data.active_users.find(x => x.id == owner_id)

  const { register, handleSubmit } = useForm({ defaultValues: data.grid });

  const onSubmitSuccess = () => {
    router.navigate("grid.edit", {id: theme_id}, {reload: true});
  }

  const onSubmit = (e) => {
    e.preventDefault();
    const error_msg = t("An error occured: the theme could not be updated");

    const cb = handleSubmit((data) => {
      updateGrid(
	theme_id, data
      ).then(response => {
        if (response.result == "ok") {
	  alert(t("Update successful"));
	  onSubmitSuccess();
        } else {
          alert(error_msg);
        }
      }).catch(e => {
        alert(error_msg);
        return e;
      })
    });

    cb();
  }

  return <div style={{display: "flex", flexDirection: "column", width: "100%"}}>
    <div>
      <h3>{ t("Owner") }</h3>
      <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
	{ user && <UserItem user={user} /> }
        <span className="c-img_buttons">
	  <span onClick={()=>{setOpen(true)}} className="c-button_edit" />
	</span>
      </div>
    </div>
    <div>
      <h3>{ t("Grid update") }</h3>
      <form onSubmit={onSubmit}>
	{ t("Description") }
	<div className="c-grid text">
	  <textarea {...register("description", {required: false})} style={{minHeight: "200px"}}>
	  </textarea>
	</div>
	<input type="submit" value={t('Save')} className="c-button publish" />
      </form>
    </div>

    {open && <div key="editing">
      <UserModal
	dataList={data.active_users}
        onClick={(user_id) => {
	  changeOwner(theme_id, user_id).then(x => {
	    setOpen(false);
	    router.navigate("grid.edit", {id: theme_id}, {reload: true});
	  })
	}}
        onClose={() => setOpen(false) }
      />
    </div>}
  </div>
}


export { SettingsPanel };
